// extracted by mini-css-extract-plugin
var _1 = "ReactPageTrainerError__button--V8T0y";
var _2 = "ReactPageTrainerError__buttonHome--utNJV ReactPageTrainerError__button--V8T0y";
var _3 = "ReactPageTrainerError__container--unu0r ErrorMessage__containerBase--Rr1du CoreGeneral__robotoSlab--X8lgW";
var _4 = "ReactPageTrainerError__image--ntvto";
var _5 = "ReactPageTrainerError__message--aFSA2 ErrorMessage__messageBase--GMVXk";
var _6 = "ReactPageTrainerError__modalPosition--y8ATP";
export { _1 as "button", _2 as "buttonHome", _3 as "container", _4 as "image", _5 as "message", _6 as "modalPosition" }
